/* Video Banner shared controls — 707dot
   - Play/pause toggle buttons ([data-video-pause])
   - Pauses autoplay background videos (video[data-autoplay]) when they
     scroll off screen or the tab is hidden, to save battery and bandwidth. */

(() => {
  // Play / pause buttons
  document.querySelectorAll('[data-video-pause]').forEach((button) => {
    button.addEventListener('click', () => {
      const container = button.closest('.video-banner, .video-banner-with-intro');
      const video = container && container.querySelector('video');
      if (!video) return;

      if (video.paused) {
        video.dataset.userPaused = '';
        video.play().catch(() => {});
        button.classList.remove('is-paused');
        button.setAttribute('aria-label', button.dataset.pauseLabel || 'Pause video');
      } else {
        video.pause();
        video.dataset.userPaused = 'true';
        button.classList.add('is-paused');
        button.setAttribute('aria-label', button.dataset.playLabel || 'Play video');
      }
    });
  });

  // Autoplay videos: pause off screen / while the tab is hidden
  const autoplayVideos = Array.from(document.querySelectorAll('video[data-autoplay]'));
  if (autoplayVideos.length === 0) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (video.dataset.userPaused === 'true') continue;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      },
      { threshold: 0 }
    );
    autoplayVideos.forEach((video) => observer.observe(video));
  }

  document.addEventListener('visibilitychange', () => {
    for (const video of autoplayVideos) {
      if (document.hidden) {
        video.pause();
      } else if (video.dataset.userPaused !== 'true') {
        video.play().catch(() => {});
      }
    }
  });
})();
